<mat-icon style="font-size: 16px" #tooltip="matTooltip" matTooltip="View" [matTooltipPosition]="tooltip_position">
    <a href="javascript:void(0)" (click)="viewClick()">remove_red_eye</a>
</mat-icon>
